import dataTable from 'datatables.net-dt';

dataTable(window, $);
